import { toRefs, reactive, computed } from 'vue'
const state = reactive({
  lead: null,
  partnerWidgetLead: null,
  b2cLead: null,
  potential: null,
  demo: false,
  version: 1,
  mapStyle: 'LIGHT',
  showDetailsReportContactPopup: false,
  showContactThankYouPopup: false,
  detailsReportContactPopupType: 'owner'
})

export function useDetailsReport () {
  return {
    ...toRefs(state)
  }
}
